import spaces from '../data/spaces'

export default function useSpaces() {
    return {
        spaces,
        loading: false,
        error: null
    }
}
